var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_924",
    "data-name": "Path 924"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.35,97.6a3,3,0,0,1-3-3V15.42a12.91,12.91,0,0,1,12.9-12.9H74.58A10.43,10.43,0,0,1,85,12.94a3,3,0,0,1-6,0,4.42,4.42,0,0,0-4.42-4.42H27.25a6.91,6.91,0,0,0-6.9,6.9V89.55L48.24,74.32a3,3,0,1,1,2.87,5.27L18.78,97.24A3,3,0,0,1,17.35,97.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_925",
    "data-name": "Path 925"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,97.6a3,3,0,0,1-1.44-.37L48.24,79.59a3,3,0,1,1,2.87-5.27L79,89.55V12.94a3,3,0,1,1,6,0V94.6a3,3,0,0,1-3,3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_32",
    "data-name": "Polygon 32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,29.6,34.44,42.77,42,55.93H57.12l7.57-13.16L57.12,29.6H42m-3.47-6H60.59l11,19.17-11,19.16H38.54l-11-19.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/Lesson.637dcc7b2e1f00bea0fc326b5610d78b.svg";
export { ForwardRef as ReactComponent };